import axios from 'axios';
import qs from 'qs';
import { StrapiResponseList } from '../interfaces/commons';
import { SurveyAnswerResponse } from '../interfaces/surveyAnswers';

const { REACT_APP_API_URL } = process.env;

export const find = async ({
  token,
  query,
}: {
  token: string | null;
  query: object;
}) => {
  const { data } = await axios.get<StrapiResponseList<SurveyAnswerResponse>>(
    `${REACT_APP_API_URL}/admin/survey-answers?${qs.stringify(query)}`,
    {
      headers: { authorization: `Bearer ${token}` },
    }
  );
  return data;
};

const surveyAnswersAPIs = {
  find,
};

export default surveyAnswersAPIs;
